import { lazy } from "react";

const Page404 = lazy(() => import("./Page404"));

const Error = ({ navigateTo }) => {
  return <Page404 navigateTo={navigateTo} />;
};
export default Error;
